// Helpers de DOM e formatação da página /melhor-cron. Todo texto dinâmico
// entra via textContent; nenhum dado de usuário é interpolado em HTML.

export const byId = (id) => document.getElementById(id);

export function el(tag, attributes = {}, children = []) {
  const node = document.createElement(tag);
  for (const [key, value] of Object.entries(attributes)) {
    if (value === undefined || value === null || value === false) continue;
    if (key === 'text') node.textContent = value;
    else if (key === 'className') node.className = value;
    else if (key === 'dataset') Object.assign(node.dataset, value);
    else if (key.startsWith('on')) node.addEventListener(key.slice(2), value);
    else node.setAttribute(key, value === true ? '' : value);
  }
  for (const child of [].concat(children)) {
    if (child === null || child === undefined || child === false) continue;
    node.append(child instanceof Node ? child : document.createTextNode(String(child)));
  }
  return node;
}

export async function api(url, init = {}) {
  const response = await fetch(url, { ...init, headers: { ...(init.body ? { 'Content-Type': 'application/json' } : {}), ...(init.headers || {}) } });
  const data = response.status === 204 ? null : await response.json().catch(() => ({}));
  if (!response.ok) throw Object.assign(new Error(data?.error || 'Não foi possível concluir.'), { status: response.status });
  return data;
}

const integer = new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 0 });
const oneDecimal = new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
const upToOneDecimal = new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 1 });
const compact = new Intl.NumberFormat('pt-BR', { notation: 'compact', maximumFractionDigits: 1 });

export const fmt = {
  int: (value) => (Number.isFinite(value) ? integer.format(value) : '—'),
  cpp: (value) => (Number.isFinite(value) ? oneDecimal.format(value) : '—'),
  pct: (value) => (Number.isFinite(value) ? `${upToOneDecimal.format(value)}%` : '—'),
  signedPct: (value) => (Number.isFinite(value) ? `${value > 0 ? '+' : ''}${upToOneDecimal.format(value)}%` : '—'),
  silver: (value) => (Number.isFinite(value) && value > 0 ? (value >= 10_000 ? compact.format(value) : integer.format(value)) : '—'),
  date: (value) => (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}/.test(value) ? value.slice(0, 10).split('-').reverse().join('/') : '—')
};

export function todayIso() {
  const now = new Date();
  return new Date(now.getTime() - now.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
}

export const LABELS = {
  packageTypes: { PACOTE: 'Pacote', TRAJE: 'Traje', CAIXA: 'Caixa', BAU: 'Baú', OUTRO: 'Outro' },
  destinations: { extract: 'Extrair Crons', sell: 'Vender no Mercado', keep: 'Manter item', other: 'Outro' },
  regions: { SA: 'SA', NA: 'NA', EU: 'EU', ASIA: 'Ásia', KR: 'KR', JP: 'JP', TW: 'TW', TH: 'TH', MENA: 'MENA', CONSOLE: 'Console' },
  bands: {
    excellent: { label: 'Excelente eficiência', icon: '▲' },
    normal: { label: 'Eficiência normal', icon: '●' },
    low: { label: 'Baixa eficiência', icon: '▼' },
    terrible: { label: 'Extremamente ruim', icon: '✖' },
    unknown: { label: 'Ainda sem comparação', icon: '○' }
  }
};

export function bandBadge(band) {
  const meta = LABELS.bands[band] || LABELS.bands.unknown;
  return el('span', { className: `mc-band mc-band-${band}` }, [el('span', { 'aria-hidden': 'true', text: meta.icon }), meta.label]);
}

// Ícones: assets do Marni direto; os do BDO Codex passam pelo cache do servidor.
export function iconUrl(path) {
  if (!path) return '';
  return path.startsWith('/assets/') ? path : `/api/tools/cron-calculator/icon?${new URLSearchParams({ path })}`;
}

// Sem ícone conhecido, um marcador neutro ocupa o mesmo espaço.
export function itemIcon(path, { size = 'md', alt = '' } = {}) {
  if (!path) return el('span', { className: `mc-icon mc-icon-${size} mc-icon-empty`, 'aria-hidden': 'true' });
  const img = el('img', { className: `mc-icon mc-icon-${size}`, src: iconUrl(path), alt, loading: 'lazy', width: size === 'sm' ? '24' : '36', height: size === 'sm' ? '24' : '36' });
  img.addEventListener('error', () => img.replaceWith(el('span', { className: `mc-icon mc-icon-${size} mc-icon-empty`, 'aria-hidden': 'true' })), { once: true });
  return img;
}
